// list of different data types in our database.
const dataTypes = ['cell_line', 'compound', 'dataset', 'gene', 'tissue'];

export default dataTypes;
